/* eslint key-spacing: ['error'] */

export const awsErrorMessages = {
    'UserNotConfirmedException': 'Account has not yet been confirmed.',
    'UserNotFoundException': 'User does not exist.',
    'UnexpectedLambdaException': 'Password required.',
    'NotAuthorizedException': 'Incorrect email or password.',
    'Incorrect username or password.': 'Incorrect current password.',
    'Attempt limit exceeded, please try after some time.': 'Attempt limit exceeded. Try again later.',
    'Username cannot be empty': 'Email cannot be empty.',
    'Cannot reset password for the user as there is no registered/verified email or phone_number': 'Cannot find that email address.',
    'Invalid verification code provided, please try again.': 'Incorrect verification code.',
    'Password did not conform with policy: Password not long enough': 'The password must have at least 8 characters.',
    '1 validation error detected: Value at \'password\' failed to satisfy constraint: Member must have length greater than or equal to 6': 'The password must have at least 8 characters.',
    '1 validation error detected: Value at \'proposedPassword\' failed to satisfy constraint: Member must have length greater than or equal to 6': 'The password must have at least 8 characters.',
    'Password did not conform with policy: Password must have uppercase characters': 'The password must have uppercase letters.',
    'Password did not conform with policy: Password must have numeric characters': 'The password must have numeric characters.',
    'Password did not conform with policy: Password must have symbol characters': 'The password must have special characters.'
};

export const getError = (error) => {
    const errorMessageKey = error.message || error;
    return awsErrorMessages[errorMessageKey] || errorMessageKey;
};
